export default __webpack_public_path__ + "2b1dee4d8ff2f0301c0ce59bff843c96.svg";